import {Divider} from 'antd';

import * as styles from './chart-tooltip.scss';

export function ChartTooltipDivider(): JSX.Element {
    return <Divider className={styles.ChartTooltip_divider} />;
}
